/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../../views/Loader/LoadingContext";
import { UseDebounce } from "../../../states/Hooks/UseDebounce";
import ApprovalListTableComponent from "../../Layouts/Table/TableHead/ApprovalListTableComponent";
import SideBarNavigation from "../../Layouts/Sidebar/Sidebar";

function ApprovalList() {
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const debouncedSearch = UseDebounce(search, 500);

  const handleCreateOrder = () => {
    navigate("/create-order");
  };

  const handleEditOrder = (orderId: number) => {
    navigate(`/purchase-orders/edit/${orderId}`);
  };

  useEffect(() => {
    setPage(0);
  }, [debouncedSearch]);

  return (
    <div className="flex h-screen bg-gray-50">
      <div className="flex-1 p-6 ml-6 overflow-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-semibold text-gray-900">
            Approval List
          </h1>
        </div>

        {/* Search Bar */}
        <div className="mb-6">
          <div className="relative max-w-md">
            <input
              type="text"
              placeholder="Search by order number or vendor..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <svg
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>

        {/* Table */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200">
          <ApprovalListTableComponent
            onEditOrder={handleEditOrder}
            currentPage={page}
            setCurrentPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            search={debouncedSearch}
          />
        </div>
      </div>
    </div>
  );
}

export default ApprovalList;